import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Form,
    Tooltip,
    Input,
    Popconfirm,
    List,
} from "antd";
import {
    UnorderedListOutlined,
    EditFilled,
    DeleteFilled,
} from "@ant-design/icons";
import { convertColumns } from "../../../../utils/columnconverter";
import { notify } from "../../../../redux/actions";
import { connect } from "react-redux";
import aictia from "../../../../const/api";
import { useTranslation } from "react-i18next";
import { whiteSpace } from "../../../../utils/rules";
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';

const PaketOfActia = (props) => {
    const mainUrl = 'PacketOfAictia'
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [positions, setPositions] = useState([]);
    const [spin, setSpin] = useState(false);
    const [editing, setEditing] = useState(null);
    const [lang, setLang] = useState([]);

    const cols = [
        { key: "index", value: "#", con: true },
        { key: "name", value: t("name"), con: true },
        { key: "id", value: "", con: false },
    ];
    const nameInput = useRef();

    // props
    const { notify } = props;

    const columns = [
        {
            title: "#",
            key: "1",
            dataIndex: "index",
            width: 80,
        },
        {
            title: t("name"),
            key: "2",
            dataIndex: "name",
        },
        {
            title: "",
            key: "3",
            dataIndex: "id",
            width: 30,
            render: (i) => {
                return (
                    <div className="flex flex-end">
                        <Popconfirm
                            placement="topRight"
                            title={t("areYouSure")}
                            onConfirm={() => deletePosition(i)}
                            okText={t("yes")}
                            cancelText={t("no")}
                        >
                            <Tooltip className="ml-5" title={t("delete")}>
                                <Button className="border-none" type="text" shape="circle">
                                    <DeleteFilled />
                                </Button>
                            </Tooltip>
                        </Popconfirm>
                        <Tooltip className="ml-5" title={t("edit")} placement="topRight">
                            <Button
                                className="border-none"
                                type="text"
                                shape="circle"
                                onClick={() => setEditingObject(i)}
                            >
                                <EditFilled />
                            </Button>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];

    const setEditingObject = async (i) => {
        setEditing(i);
        await aictia.get(mainUrl + `/${i}`).then((res) => {
            let obj = {};
            res.data.packetOfAictia_Languages.map((item) => {

                obj[`name_${item.languageId}`] = item.name;

            }
            );
            form.setFieldsValue(obj);
        });
    };

    const cancelEditing = () => {
        setEditing(null);
        form.resetFields();
    };

    const deletePosition = async (i) => {
        await aictia
            .delete(`${mainUrl}/${i}`)
            .then(() => {
                // description
                notify("silindi", true);
                getPositions();
            })
            .catch((err) => {
                //error
                notify(err.response, false);
            });
    };

    const savePosition = async (values) => {
        ;
        let obj = {
            packetOfAictia_Languages: lang.map((lang, index) => {
                return { languageId: lang.id, name: values[`name_${lang.id}`] };
            }),
        };
        if (!editing) {
            await aictia
                .post(mainUrl, obj)
                .then((res) => {
                    notify("", true);
                    getPositions();
                    cancelEditing();
                })
                .catch((err) => {
                    notify(err.response, false);
                });
        } else {
            await aictia
                .put(`${mainUrl}/${editing}`, { id: editing, ...obj })
                .then((res) => {
                    notify("", true);
                    getPositions();
                    cancelEditing();
                })
                .catch((err) => {
                    notify(err.response, false);
                });
        }
    };

    const getPositions = async () => {
        setSpin(true);
        await aictia.get(mainUrl).then((res) => {
            setSpin(false);
            setPositions(
                res.data.map((p, index) => {
                    return {
                        key: index + 1,
                        ...p,
                        index: index + 1,
                    };
                })
            );
        });
    };

    const getLanguage = async () => {

        await aictia.get('Language').then((res) => {

            setLang(res.data)
        });
    };

    useEffect(() => {
        getPositions();
        getLanguage();
    }, [t]);

    return (
        <Row gutter={[10, 10]} className="pl-1">
            <Col xs={24}>
                <div className="border flex animated fadeInDown p-2 mt-0 bg-white" style={{ borderRadius: '20px' }}>
                    <span
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: 12,
                            background: "#eff6ff",
                            color: "#0c82f4",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 10,
                            marginTop: 5,
                        }}
                    >
                        <UnorderedListOutlined className="f-20" />
                    </span>
                    <div>
                        <span className="f-20 bold">{t('membershipPackage')}</span>
                        <p className="text-[11px] text-slate-450 font-medium">{t("membershipPackageSub")}</p>
                    </div>
                </div>
            </Col>
            <Col lg={12} xs={24}>
                <div
                    style={{
                        background: "#fff",
                        border: "1px solid rgba(226,232,240,.85)",
                        borderRadius: 16,
                        padding: 16,
                        boxShadow: "0 1px 2px rgba(15,23,42,.04)",
                    }}
                >
                    <List
                        grid={{
                            gutter: 12,
                            xs: 1,
                            sm: 1,
                            md: 2,
                            lg: 2,
                            xl: 2,
                            xxl: 2,
                        }}
                        loading={spin}
                        dataSource={convertColumns(positions, cols)}
                        locale={{ emptyText: "Siyahı boşdur." }}
                        renderItem={(item, index) => (
                            <List.Item
                                style={{
                                    background: "#f8fafc",
                                    border: "1px solid rgba(226,232,240,.9)",
                                    borderRadius: 12,
                                    padding: "10px 14px",
                                    marginBottom: 8,
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    {/* INDEX */}
                                    <div
                                        style={{
                                            width: 50,
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <span
                                            style={{
                                                minWidth: 22,
                                                height: 22,
                                                padding: "0 6px",
                                                background: "#fff",
                                                border: "1px solid #cfd6df",
                                                borderRadius: 6,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: 11,
                                                fontWeight: 700,
                                                fontFamily: "monospace",
                                                color: "#111",
                                            }}
                                        >
                                            {index + 1}
                                        </span>
                                    </div>

                                    {/* NAME */}
                                    <div
                                        style={{
                                            flex: 1,
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: "#111827",
                                        }}
                                    >
                                        {item.name}
                                    </div>

                                    {/* ACTIONS */}
                                    <div
                                        style={{
                                            width: 90,
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 10,
                                        }}
                                    >
                                        <EditFilled
                                            onClick={() => setEditingObject(item)}
                                            style={{
                                                fontSize: 15,
                                                color: "#64748b",
                                                cursor: "pointer",
                                            }}
                                        />

                                        <DeleteFilled
                                            onClick={() => deletePosition(item.id)}
                                            style={{
                                                fontSize: 15,
                                                color: "#64748b",
                                                cursor: "pointer",
                                            }}
                                        />
                                    </div>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>
            </Col>
            <Col lg={12} xs={24}>
                <Card title={t("addTo")} className={"animated fadeInRight administrator "} style={{ borderRadius: '20px' }}>
                    <Form layout="vertical" onFinish={savePosition} form={form}>
                        {
                            lang.map((item, index) => {
                                return (
                                    <div className="form-lang mb-20" key={index}>
                                        <FloatLabel>

                                            <Form.Item
                                                className="mb-5"
                                                validateTrigger="onChange"
                                                name={`name_${item.id}`}
                                                rules={[whiteSpace(t("inputError"))]}
                                            >
                                                <InputText ref={nameInput} className="w-full" id={`name_${item.id}`} style={{ borderRadius: '12px' }} />
                                            </Form.Item>
                                            <label htmlFor={`name_${item.id}`}>{item.id == 1 ? 'Üzvlüklərin adı' : item.id == 2 ? 'Üyeliklerin adı' : item.id == 3 ? 'Название членств' : item.id == 4 ? 'Membership names' : ''}</label>

                                            <div className="input-lang">{item.uniCode}</div>
                                        </FloatLabel>
                                    </div>
                                )
                            })
                        }

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: 15,
                                width: "100%",
                            }}
                        >
                            <Button
                                onClick={cancelEditing}
                                style={{
                                    height: 36,
                                    padding: "0 16px",
                                    borderRadius: 10,
                                    background: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: "#334155",
                                }}
                            >
                                {t("cancel")}
                            </Button>

                            <Button
                                htmlType="submit"
                                style={{
                                    height: 36,
                                    padding: "0 16px",
                                    borderRadius: 10,
                                    background: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: "#334155",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                {t("save")}
                            </Button>
                        </div>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};

const mapStateToProps = ({ langs }) => {
    return {
        langs: langs,
    };
};

export default connect(mapStateToProps, { notify })(PaketOfActia);
